import React from "react";

function Loading() {
  return <p>Seite wird geladen ...</p>;
}

export default Loading;
